import { useLocation, useNavigate } from "react-router-dom";
import {
  getStoreLocalData,
  getUserData,
} from "../../utils/localStorage";
import SchedularModal from "../SchedularModal";
import StatusFilterModal from "../StatusFilterModal";
import { useEffect, useState } from "react";
import { Accordion, AccordionTab } from "primereact/accordion";
import ButtonLink from "../../ButtonLink";
import useOrders from "../StoreContext/useOrders";
import StoreSelectionModal from "../StoreSelectionModal";
import AdminMenu from "../AdminMenu";
import { getFranchiseRateList, getFranchiseStoreMappedList, getFranchiseStoreOrderRevenue } from "../../services/FranchiseModal/Franchise";
import FranchiseStatusFilterModal from "../FranchiseStatusFilterModal";
import SchedularModalFranchise from "../SchedularModalFranchise";
import { localeDateEndDate, localeDateStartDate } from "../../constants/DateUtil/DateUtil";

const FranchiseStoreOrderRevenueAdmin = () => {
  const navigate = useNavigate();

  const location = useLocation();
  const { item, storeName } = location.state || {};

  const { userProfileRole, brandProfileData } = getUserData();
  const { storeLocalData } = getStoreLocalData();

  const userRole = userProfileRole;
  let brandId = brandProfileData.id;

  const [schedularModalVisible, setSchedularModalVisible] = useState(false);
  const [statusFilterModalVisible, setStatusFilterModalVisible] =
    useState(false);
  const [franchiseOrderRevenueData, setFranchiseOrderRevenueData] = useState(
    []
  );
  const [loading, setLoading] = useState(false);
  const [loadingSearch, setLoadingSearch] = useState(false);
  const [visible, setVisible] = useState(false);
  const [storeSelectionModalVisible, setStoreSelectionModalVisible] =
    useState(false);
  const [brandStoreIdsData, setBrandStoreIdsData] = useState([]);
  const [brandStoreData, setBrandStoreData] = useState([]);

  const [localFranchiseRateValue, setLocalFranchiseRateValue] = useState([]);

  const {
    schedularDate,
    setSchedularDate,
    selectedStatus,
    setSelectedStatus,
    upDateSelectedStatus,
    setUpDateSelectedStatus,
    useEffectCall,
    setUseEffectCall,
    selectedStore,
    setSelectedStore,
    upDateSelectedStore,
    setUpDateSelectedStore,
  } = useOrders();

  const initializeVariable = () => {
    setFranchiseOrderRevenueData([]);
  };

  const handleCalendarModal = () => {
    setSchedularModalVisible(true);
  };

  const handleFilterModal = () => {
    setStatusFilterModalVisible(true);
    // Close the filter modal or perform any other necessary actions
  };

  // const [schedularDate, setSchedularDate] = useState({});
  const receiveDataFromSchedularModal = ({ newSchedular }) => {
    setUseEffectCall(true);

    setSchedularDate(newSchedular);
  };

  const receiveDataFromStatusFilterModal = (selectedStatus) => {
    setUseEffectCall(true);

    setSelectedStatus(selectedStatus);
  };

  const receiveDataFromStoreSelectionModal = (selectedStore) => {
    setUseEffectCall(true);

    setSelectedStore(selectedStore);
  };

  // let initialStartDate = new Date();
  // initialStartDate.setDate(initialStartDate.getDate() - 30); // subtract 7 days to current date

  let initialStartDate = new Date();
  initialStartDate.setDate(1); // Set to the 1st of the current month

  // If orderFilterData is available, use its start and end dates
  const [startDate, setStartDate] = useState(new Date(initialStartDate));
  let initialEndDate = new Date();
  const [endDate, setEndDate] = useState(new Date(initialEndDate));
  const [apiCall, setApiCall] = useState(false)

  const fetchStoreOrderRevenue = (data) => {
    setLoading(true);
    getFranchiseStoreOrderRevenue(data)
      .then((response) => {
        if (!response.data.error) {
          const Res = response.data;
          setApiCall(true)

          setFranchiseOrderRevenueData(Res);

          setLoading(false);
          setLoadingSearch(false);
        }
      })
      .catch((err) => {
        console.error("Error:", err);
        setLoading(false);
        setLoadingSearch(false);
      });
  };

  // for all status and one week data or by default data;
  const data = {
    storeIds: [item.storeId],
    brandId: brandId,
    statusIn: [
      "BOOKED",
      "INPROCESS",
      "IN_WAREHOUSE",
      "PROCESSED",
      "DELIVERED",
      "DONE",
      // "CANCEL",
      // "UNPROCESSED",
      "OUT_FOR_DELIVERY",
      "DELAY_STATUS",
    ],
    startDate: localeDateStartDate(new Date(startDate)),
    endDate: localeDateEndDate(new Date(endDate)),
  };

  const [requestData, setRequestData] = useState(data);

  const OrderStatusColors = [
    "#3EB3E1",
    "#866CCE",
    "#F5C43A",
    "#09B4AA",
    "#55BD5A",
    "#FF6767",
    "#5D53D8",
    "#6EA4F5",
    "#E89534",
    "#a906c2",
    "#3EB3E1",
    "#866CCE",
    "#F5C43A",
    "#09B4AA",
    "#55BD5A",
    "#FF6767",
    "#5D53D8",
    "#6EA4F5",
    "#E89534",
    "#a906c2",
    "#3EB3E1",
    "#866CCE",
    "#F5C43A",
    "#09B4AA",
    "#55BD5A",
    "#FF6767",
    "#5D53D8",
    "#6EA4F5",
    "#E89534",
    "#a906c2",
    "#3EB3E1",
    "#866CCE",
    "#F5C43A",
    "#09B4AA",
    "#55BD5A",
    "#FF6767",
    "#5D53D8",
    "#6EA4F5",
    "#E89534",
    "#a906c2",
    "#000",
  ];

  useEffect(() => {
    if (useEffectCall) {
      initializeVariable();
      if (selectedStatus !== "ALL") {
        requestData.statusIn = selectedStatus;
      } else {
        requestData.statusIn = [
          "BOOKED",
          "INPROCESS",
          "IN_WAREHOUSE",
          "PROCESSED",
          "DELIVERED",
          "DONE",
          // "CANCEL",
          // "UNPROCESSED",
          "OUT_FOR_DELIVERY",
          "DELAY_STATUS",
        ];
      }
      requestData.startDate = schedularDate?.startDate
        ? localeDateStartDate(new Date(schedularDate.startDate))
        : localeDateStartDate(new Date(startDate));
      requestData.endDate = schedularDate?.endDate
        ? localeDateEndDate(new Date(schedularDate.endDate))
        : localeDateEndDate(new Date(endDate));
      fetchStoreOrderRevenue(requestData);
    }
  }, [schedularDate, selectedStatus]);

  useEffect(() => {
    fetchFranchiseRate();
  }, []);
   
  const fetchFranchiseRate = () => {
    setLoading(true);
    getFranchiseRateList(brandId, item.brandFranchise.id)
      .then((response) => {
        if (!response.data.error) {
          const Res = response.data.filter((item) => item.status === true);
          setLocalFranchiseRateValue(Res);
          setLoading(false);
        }
      })
      .catch((err) => {
        console.error("Error:", err);
      });
  };

  const prepareExportData = () => {
    return franchiseOrderRevenueData.map((item) => {
      const store = brandStoreData?.find(
        (storeItem) => storeItem.id === item.storeId
      );
      const storeName = store?.storeName || "N/A";

      const netRate = localFranchiseRateValue?.find(
        (rate) => rate?.status === true && rate?.calculationMode === "NET"
      )?.rate;

      const grossRate = localFranchiseRateValue?.find(
        (rate) => rate?.status === true && rate?.calculationMode === "GROSS"
      )?.rate;

      const baseNetAmount = netRate
        ? item?.totalTaxableAmount * (netRate / 100)
        : 0;
      const baseGrossAmount = grossRate
        ? item?.totalAmount * (grossRate / 100)
        : 0;

      const currencySymbol = storeLocalData?.currencySymbol || "";

      return {
        "Store Name": storeName,
        "Total Orders": item?.totalOrder || 0,
        "Total Items (Garments)": item?.totalItemGarmentCount || 0,
        [`Gross Amount (${currencySymbol})`]: item?.totalAmount || 0,
        [`Total Charge Amount (${currencySymbol})`]: item?.totalChargeAmount || 0,
        [`Total Discount Amount (${currencySymbol})`]: item?.totalDiscountAmount || 0,
        [`Total Offer Discount (${currencySymbol})`]: item?.totalOfferDiscount || 0,
        [`Total Subscription Discount (${currencySymbol})`]: item?.totalSubscriptionDiscount || 0,
        [`Total Taxable Amount (${currencySymbol})`]: item?.totalTaxableAmount || 0,
        [`Total ${storeLocalData?.taxType} Amount (${currencySymbol})`]: item?.totalGstAmount || 0,
        [`Total Paid Amount (${currencySymbol})`]: item?.totalPaidAmount || 0,
        [`Total Refund Amount (${currencySymbol})`]: item?.totalRefundAmount || 0,
        [`Total Balance Amount (${currencySymbol})`]: item?.totalBalanceAmount || 0,
        [`Total Grand Total (${currencySymbol})`]: item?.totalGrandTotal || 0,
        [`Total Delivery Discount (${currencySymbol})`]: item?.totalDeliveryDiscount || 0,
        [`Total Delivery Charge (${currencySymbol})`]: item?.totalDeliveryCharge || 0,
        "Revenue Share (Net)": netRate
          ? `${
              item?.totalTaxableAmount
          } x ${netRate}% = ${currencySymbol} ${baseNetAmount.toFixed(2)}`
          : "N/A",
        "Revenue Share (Gross)": grossRate
          ? `${item?.totalAmount} x ${grossRate}% = ${currencySymbol} ${baseGrossAmount.toFixed(
              2
            )}`
          : "N/A",
      };
    });
  };


  const exportExcel = () => {
    import("xlsx").then((xlsx) => {
      const exportData = prepareExportData();
      const worksheet = xlsx.utils.json_to_sheet(exportData);
      const workbook = { Sheets: { data: worksheet }, SheetNames: ["data"] };
      const excelBuffer = xlsx.write(workbook, {
        bookType: "xlsx",
        type: "array",
      });

      saveAsExcelFile(excelBuffer, "StoreOrderRevenue");
    });
  };


  const saveAsExcelFile = (buffer, fileName) => {
    import("file-saver").then((module) => {
      if (module && module.default) {
        let EXCEL_TYPE =
          "application/vnd.openxmlformats-officedocument.spreadsheetml.sheet;charset=UTF-8";
        let EXCEL_EXTENSION = ".xlsx";
        const data = new Blob([buffer], {
          type: EXCEL_TYPE,
        });

        module.default.saveAs(
          data,
          fileName + "_export_" + new Date().getTime() + EXCEL_EXTENSION
        );
      }
    });
  };


  const renderDashboardCards = () => {
    return franchiseOrderRevenueData.map((item, index) => {

      const netRateList = localFranchiseRateValue?.filter(
        (itemRate) =>
          itemRate?.status === true && itemRate?.calculationMode === "NET"
      );

      const grossRateList = localFranchiseRateValue?.filter(
        (itemRate) =>
          itemRate?.status === true && itemRate?.calculationMode === "GROSS"
      );

      const ratePercentage = netRateList[0]?.rate / 100; // e.g., 20 for 20%
      const baseNetAmount = item?.totalTaxableAmount * ratePercentage;

      const grossPercentage = grossRateList[0]?.rate / 100; // e.g., 20 for 20%
      const baseGrossAmount = item?.totalAmount * grossPercentage;

      return (
        <Accordion>
          <AccordionTab
            key={index} // Use a more unique key like data.id
            style={{
              "--backgroundColor-AccordionTab": OrderStatusColors[index],
            }}
            header={`StoreName : ${storeName || "N/A"}`}
          >
            <div className="cursor-pointer">
              <div className="flex-row">
                <div className="col-4">
                  <p className="text-base font-semiBold capitalize">
                    Total Order:
                  </p>
                  <p className="text-lg font-bold capitalize">
                    {item?.totalOrder || 0}
                  </p>
                </div>
                <div className="col-4">
                  <p className="text-base font-semiBold capitalize">
                    Total Item Garment Count:
                  </p>
                  <p className="text-lg font-bold capitalize">
                    {item?.totalItemGarmentCount || 0}
                  </p>
                </div>
                <div className="col-4">
                  <p className="text-base font-semiBold capitalize">
                    Gross Amount:
                  </p>
                  <p className="text-lg font-bold capitalize">
                    {storeLocalData?.currencySymbol} {item?.totalAmount || 0}
                  </p>
                </div>
              </div>

              <div className="flex-row">
                <div className="col-4">
                  <p className="text-base font-semiBold capitalize">
                    Total Charge Amount:
                  </p>
                  <p className="text-lg font-bold capitalize">
                    {storeLocalData?.currencySymbol} {item?.totalChargeAmount || 0}
                  </p>
                </div>
                <div className="col-4">
                  <p className="text-base font-semiBold capitalize">
                    Total Discount Amount:
                  </p>
                  <p className="text-lg font-bold capitalize">
                    {storeLocalData?.currencySymbol} {item?.totalDiscountAmount || 0}
                  </p>
                </div>
                <div className="col-4">
                  <p className="text-base font-semiBold capitalize">
                    Total Offer Discount:
                  </p>
                  <p className="text-lg font-bold capitalize">
                    {storeLocalData?.currencySymbol} {item?.totalOfferDiscount || 0}
                  </p>
                </div>
              </div>

              <div className="flex-row">
                <div className="col-4">
                  <p className="text-base font-semiBold capitalize">
                    Total Subscription Discount:
                  </p>
                  <p className="text-lg font-bold capitalize">
                    {storeLocalData?.currencySymbol} {item?.totalSubscriptionDiscount || 0}
                  </p>
                </div>

                <div className="col-4">
                  <p className="text-base font-semiBold capitalize">
                    Total Taxable Amount:
                  </p>
                  <p className="text-lg font-bold capitalize">
                    {storeLocalData?.currencySymbol} {item?.totalTaxableAmount || 0}
                  </p>
                </div>
                <div className="col-4">
                  <p className="text-base font-semiBold capitalize">
                    Total {storeLocalData?.taxType} Amount:
                  </p>
                  <p className="text-lg font-bold capitalize">
                    {storeLocalData?.currencySymbol} {item?.totalGstAmount || 0}
                  </p>
                </div>
              </div>

              <div className="flex-row">
                <div className="col-4">
                  <p className="text-base font-semiBold capitalize">
                    Total Paid Amount:
                  </p>
                  <p className="text-lg font-bold capitalize">
                    {storeLocalData?.currencySymbol} {item?.totalPaidAmount || 0}
                  </p>
                </div>
                <div className="col-4">
                  <p className="text-base font-semiBold capitalize">
                    Total Refund Amount:
                  </p>
                  <p className="text-lg font-bold capitalize">
                    {storeLocalData?.currencySymbol} {item?.totalRefundAmount || 0}
                  </p>
                </div>
                <div className="col-4">
                  <p className="text-base font-semiBold capitalize">
                    Total Balance Amount:
                  </p>
                  <p className="text-lg font-bold capitalize">
                    {storeLocalData?.currencySymbol} {item?.totalBalanceAmount || 0}
                  </p>
                </div>
              </div>
              <div className="flex-row">
                <div className="col-4">
                  <p className="text-base font-semiBold capitalize">
                    Total Grand Total:
                  </p>
                  <p className="text-lg font-bold capitalize">
                    {storeLocalData?.currencySymbol} {item?.totalGrandTotal || 0}
                  </p>
                </div>
                <div className="col-4">
                  <p className="text-base font-semiBold capitalize">
                    Total Delivery Discount:
                  </p>
                  <p className="text-lg font-bold capitalize">
                    {storeLocalData?.currencySymbol} {item?.totalDeliveryDiscount || 0}
                  </p>
                </div>
                <div className="col-4">
                  <p className="text-base font-semiBold capitalize">
                    Total Delivery Charge:
                  </p>
                  <p className="text-lg font-bold capitalize">
                    {storeLocalData?.currencySymbol} {item?.totalDeliveryCharge || 0}
                  </p>
                </div>
              </div>
              <div className="flex-row">
                {baseNetAmount >= 0 && (
                  <div className="col-6">
                    <p className="text-base font-semiBold capitalize">
                      Revenue Sharing Calculation (Net Amount) :
                    </p>
                    <p className="text-lg font-bold capitalize">
                      Taxable Amount x Revenue Sharing Rate = Calculated Share
                    </p>

                    <p className="text-lg font-bold capitalize">
                      {item?.totalTaxableAmount} x {netRateList[0]?.rate}% = {storeLocalData?.currencySymbol}{" "}
                      {baseNetAmount.toFixed(2)}
                    </p>
                  </div>
                )}
                {baseGrossAmount >= 0 && (
                  <div className="col-6">
                    <p className="text-base font-semiBold capitalize">
                      Revenue Sharing Calculation (Gross Amount):
                    </p>
                    <p className="text-lg font-bold capitalize">
                      Gross Amount x Revenue Sharing Rate = Calculated Share
                    </p>

                    <p className="text-lg font-bold capitalize">
                      {item?.totalAmount} x {grossRateList[0]?.rate}% = {storeLocalData?.currencySymbol}{" "}
                      {baseGrossAmount.toFixed(2)}
                    </p>
                  </div>
                )}
              </div>
            </div>
          </AccordionTab>
        </Accordion>
      );
    });
  };

  return (
    <div className="flex-1">
      <div
        className="h-3rem surface-0 sticky z-2 top-0 flex justify-content-center align-items-center"
        style={{
          "--surface-0": "#1752AA",
        }}
      >
        <div className="flex-1 flex ml-3 mr-3">
          <div className="flex-1 flex ">
            <div className="ml-3 flex justify-content-center align-items-center">
              <div className="h-1rem w-1rem border-circle flex justify-content-center align-items-center">
                <i
                  className="pi pi-angle-left"
                  onClick={() => navigate(-1)}
                  style={{ fontSize: "27px", cursor: "pointer", color: "#fff" }}
                ></i>
              </div>
            </div>
            <div className="flex-1 ml-5">
              <p className="text-white text-2xl font-bold uppercase">
                Store Order Revenue
              </p>
            </div>
          </div>
          {franchiseOrderRevenueData.length > 0 && (
            <div className="flex justify-content-center align-items-center">
              <div className="flex justify-content-center align-items-center cursor-pointer mx-2">
                <img
                  onClick={exportExcel}
                  src={"images/file.png"}
                  style={{
                    width: 30,
                  }}
                  alt=""
                />
              </div>
            </div>
          )}
          <div
            onClick={() => handleCalendarModal()}
            className="mx-2 cursor-pointer"
          >
            <img
              src={"Laundy_App_Icons_Gifs/Other_Icons/schedule.png"}
              style={{ width: 27 }}
            />
          </div>

          <div
            onClick={() => handleFilterModal("DELIVERED")}
            className="mx-2 cursor-pointer"
          >
            <img
              src={"Laundy_App_Icons_Gifs/Other_Icons/filter.png"}
              style={{ width: 27 }}
            />
          </div>
          <div
            className="flex justify-content-center align-items-center cursor-pointer"
            onClick={() => setVisible(true)}
          >
            <i
              className="pi pi-bars"
              style={{ fontSize: "27px", marginRight: 30, color: "#fff" }}
            ></i>
          </div>
        </div>
      </div>

      <div className="my-2">
        <div className="mx-4 my-2">
          {franchiseOrderRevenueData.length > 0 ? (
            renderDashboardCards()
          ) : apiCall === false ? (
            <div className="flex justify-content-center my-2">
              <p className="text-2xl font-semi-bold" style={{ color: "green" }}>Please Select Start Date & End Date to Get Revenue.</p>
            </div>
          ) : (
            <div className="flex justify-content-center my-2">
              <p className="text-4xl font-semi-bold">No Data Found</p>
            </div>
          )}
        </div>
        <SchedularModalFranchise
          setSchedularModalVisible={setSchedularModalVisible}
          schedularModalVisible={schedularModalVisible}
          sendDataToOrdersPage={receiveDataFromSchedularModal}
          minimumDateFranchise={item?.revenueCalculateOn}
        />
        <FranchiseStatusFilterModal
          setStatusFilterModalVisible={setStatusFilterModalVisible}
          statusFilterModalVisible={statusFilterModalVisible}
          sendDataToOrdersPageFromFilter={receiveDataFromStatusFilterModal}
          upDateSelectedStatus={upDateSelectedStatus}
          OrderStatus={[
            "BOOKED",
            "INPROCESS",
            "IN_WAREHOUSE",
            "PROCESSED",
            "DELIVERED",
            "DONE",
            // "CANCEL",
            // "UNPROCESSED",
            "OUT_FOR_DELIVERY",
            "DELAY_STATUS",
          ]}
        />
        <StoreSelectionModal
          setStoreSelectionModalVisible={setStoreSelectionModalVisible}
          storeSelectionModalVisible={storeSelectionModalVisible}
          sendDataToOrdersPageFromFilter={receiveDataFromStoreSelectionModal}
          upDateSelectedStore={upDateSelectedStore}
          brandStoreData={brandStoreData}
        />
        <AdminMenu setVisible={setVisible} visible={visible} />
        <ButtonLink />
      </div>
    </div>
  );
};

export default FranchiseStoreOrderRevenueAdmin;
